<!-- DARK THEME NAVBAR - REDESIGNED -->

<nav id="navbar" class="fixed w-full top-0 z-50 bg-black/95 backdrop-blur-lg border-b border-varroc-border transition-all duration-300 shadow-lg">
  <div class="w-full flex items-center px-6 py-3">
    <!-- Logo (left) -->
    <div class="flex-1 flex items-center min-w-0">
      <a routerLink="/" class="flex items-center gap-2 group">
        <img [src]="Images.VARROC_CONNECT_LOGO" alt="Varroc Connect Logo" class="h-16 drop-shadow-neon transition-transform group-hover:scale-105">
      </a>
    </div>
    <!-- Desktop Navigation (right) -->
    <div class="hidden md:flex flex-1 justify-end items-center gap-1 text-sm font-medium min-w-0">

      <!-- Solutions Dropdown -->
      <div class="relative group">
        <a routerLink="/solutions" class="hover:text-varroc-accent transition flex items-center gap-1 px-3 py-2 rounded-lg focus:outline-none">
          Solutions <i class='bx bx-chevron-down text-lg'></i>
        </a>
        <div class="absolute top-full left-0 mt-2 w-72 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-3 backdrop-blur-xl">
          <div class="px-4 pb-2 pt-1">
            <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold mb-2">By Audience</p>
          </div>
          <!-- For Business with nested flyout -->
          <div class="relative group/biz mx-2 mb-1">
            <a routerLink="/solutions/business" class="flex items-center justify-between gap-3 px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg">
              <div class="flex items-center gap-3">
                <i class='bx bx-buildings icon-gradient text-xl'></i>
                <div>
                  <div class="text-white font-semibold text-sm group-hover/biz:text-varroc-accent transition-colors">Business</div>
                  <div class="text-varroc-text-gray text-xs">OEM, Fleet, Insurance, Enterprise</div>
                </div>
              </div>
              <i class='bx bx-chevron-right text-varroc-text-gray text-base flex-shrink-0'></i>
            </a>
            <div class="absolute left-full top-0 ml-2 w-60 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover/biz:opacity-100 group-hover/biz:visible transition-all duration-200 py-3 backdrop-blur-xl z-50">
              <div class="px-4 pb-2 pt-1">
                <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold">Business</p>
              </div>
              <a routerLink="/solutions/business/automotive-oem" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-car icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Automotive OEM</div><div class="text-varroc-text-gray text-xs">Vehicle OEM solutions</div></div>
              </a>
              <a routerLink="/solutions/business/fleet-logistics" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-transfer icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Fleet & Logistics</div><div class="text-varroc-text-gray text-xs">Fleet management & tracking</div></div>
              </a>
              <a routerLink="/products/connectiq/iiot" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-network-chart icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">IIOT</div><div class="text-varroc-text-gray text-xs">Industrial IoT connectivity</div></div>
              </a>
              <a routerLink="/solutions/business/insurance" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-shield-quarter icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Insurance (BFSI)</div><div class="text-varroc-text-gray text-xs">Telematics for insurers</div></div>
              </a>
              <a routerLink="/solutions/business/enterprise" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-building icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Enterprise</div><div class="text-varroc-text-gray text-xs">Enterprise-grade solutions</div></div>
              </a>
            </div>
          </div>
          <!-- For Consumers with nested flyout -->
          <div class="relative group/con mx-2">
            <a routerLink="/solutions/consumers" class="flex items-center justify-between gap-3 px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg">
              <div class="flex items-center gap-3">
                <i class='bx bx-user icon-gradient text-xl'></i>
                <div>
                  <div class="text-white font-semibold text-sm group-hover/con:text-varroc-accent transition-colors">Consumers</div>
                  <div class="text-varroc-text-gray text-xs">Connected car, safety & rewards</div>
                </div>
              </div>
              <i class='bx bx-chevron-right text-varroc-text-gray text-base flex-shrink-0'></i>
            </a>
            <div class="absolute left-full top-0 ml-2 w-60 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover/con:opacity-100 group-hover/con:visible transition-all duration-200 py-3 backdrop-blur-xl z-50">
              <div class="px-4 pb-2 pt-1">
                <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold">Consumers</p>
              </div>
              <a routerLink="/solutions/consumers/connected-car" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-wifi icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Connected Car</div><div class="text-varroc-text-gray text-xs">Vehicle intelligence platform</div></div>
              </a>
              <a routerLink="/solutions/consumers/safety-alerts" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-bell icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Safety & Alerts</div><div class="text-varroc-text-gray text-xs">Real-time driver safety</div></div>
              </a>
              <a routerLink="/solutions/consumers/rewards" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-gift icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Rewards</div><div class="text-varroc-text-gray text-xs">Loyalty & rewards platform</div></div>
              </a>
              <a routerLink="/solutions/consumers/device-store" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-store icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Device Store</div><div class="text-varroc-text-gray text-xs">Connected devices marketplace</div></div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Platform -->
      <!-- <a routerLink="/platform" class="hover:text-varroc-accent transition px-3 py-2 rounded-lg">Platform</a> -->

      <!-- Products Dropdown -->
      <div class="relative group">
        <a  routerLink="/products" class="hover:text-varroc-accent transition flex items-center gap-1 px-3 py-2 rounded-lg focus:outline-none">
          Products <i class='bx bx-chevron-down text-lg'></i>
        </a>
        <div class="absolute top-full left-0 mt-2 w-80 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-3 backdrop-blur-xl">
          <!-- Software -->
          <div class="px-4 pb-1 pt-1">
            <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold mb-2">Software</p>
          </div>

          <!-- ConnectIQ with nested flyout -->
          <div class="relative group/ciq mx-2 mb-1">
            <a routerLink="/products/connectiq" class="flex items-center justify-between gap-3 px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg">
              <div class="flex items-center gap-3">
                <i class='bx bx-wifi icon-gradient text-xl'></i>
                <div>
                  <div class="text-white font-semibold text-sm group-hover/ciq:text-varroc-accent transition-colors">ConnectIQ</div>
                  <div class="text-varroc-text-gray text-xs">Data ingestor, AI engine, rewards</div>
                </div>
              </div>
              <i class='bx bx-chevron-right text-varroc-text-gray text-base flex-shrink-0'></i>
            </a>
            <!-- ConnectIQ children flyout -->
            <div class="absolute left-full top-0 ml-2 w-64 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover/ciq:opacity-100 group-hover/ciq:visible transition-all duration-200 py-3 backdrop-blur-xl z-50">
              <div class="px-4 pb-2 pt-1">
                <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold">ConnectIQ Products</p>
              </div>
              <a routerLink="/products/connectiq/secureiq" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-shield-quarter icon-gradient text-lg'></i>
                <div>
                  <div class="text-white font-semibold text-sm">SecureIQ</div>
                  <div class="text-varroc-text-gray text-xs">PKI & zero-trust security</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/iq360" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-message-dots icon-gradient text-lg'></i>
                <div>
                  <div class="text-white font-semibold text-sm">iQ360</div>
                  <div class="text-varroc-text-gray text-xs">Journey messaging layer</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/vstore" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-store-alt icon-gradient text-lg'></i>
                <div>
                  <div class="text-white font-semibold text-sm">V-Store</div>
                  <div class="text-varroc-text-gray text-xs">Marketplace & Redemption</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/miles" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <img [src]="GradientIcons.MILES" alt="Varroc Miles icon" class="w-5 h-5 object-contain flex-shrink-0" />
                <div>
                  <div class="text-white font-semibold text-sm">Varroc Miles</div>
                  <div class="text-varroc-text-gray text-xs">Loyalty & Rewards Program</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/cap" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-user-check icon-gradient text-lg'></i>
                <div>
                  <div class="text-white font-semibold text-sm">CAP</div>
                  <div class="text-varroc-text-gray text-xs">Customer Adoption Program</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/vc-score" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <img [src]="GradientIcons.VC_SCORE" alt="VC-SCORE icon" class="w-5 h-5 object-contain flex-shrink-0" />
                <div>
                  <div class="text-white font-semibold text-sm">VC-SCORE</div>
                  <div class="text-varroc-text-gray text-xs">Driver Intelligence & Analytics</div>
                </div>
              </a>
              <div class="mx-4 my-2 border-t border-varroc-border"></div>
              <a routerLink="/products/connectiq/oasis" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <img [src]="GradientIcons.OASIS" alt="Oasis icon" class="w-5 h-5 object-contain flex-shrink-0" />
                <div>
                  <div class="text-white font-semibold text-sm">Oasis</div>
                  <div class="text-varroc-text-gray text-xs">Connected OTA Platform</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/iiot" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-network-chart icon-gradient text-lg'></i>
                <div>
                  <div class="text-white font-semibold text-sm">IIOT</div>
                  <div class="text-varroc-text-gray text-xs">Industrial IoT Connectivity</div>
                </div>
              </a>
              <a routerLink="/products/connectiq/vehicle-app-store" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <img [src]="GradientIcons.VEHICLE_APP_STORE" alt="Vehicle App Store icon" class="w-5 h-5 object-contain flex-shrink-0" />
                <div>
                  <div class="text-white font-semibold text-sm">Vehicle App Store</div>
                  <div class="text-varroc-text-gray text-xs">In-vehicle App Marketplace</div>
                </div>
              </a>
            </div>
          </div>

          <!-- Unified SDK with nested flyout -->
          <div class="relative group/sdk mx-2">
            <a routerLink="/products/unifiedsdk" class="flex items-center justify-between gap-3 px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg">
              <div class="flex items-center gap-3">
                <i class='bx bx-code-block icon-gradient text-xl'></i>
                <div>
                  <div class="text-white font-semibold text-sm group-hover/sdk:text-varroc-accent transition-colors">Unified SDK</div>
                  <div class="text-varroc-text-gray text-xs">Mobile, Web & IoT SDK</div>
                </div>
              </div>
              <!-- <i class='bx bx-chevron-right text-varroc-text-gray text-base flex-shrink-0'></i> -->
            </a>
          </div>
          <div class="mx-4 mb-2 mt-1 border-t border-varroc-border"></div>
          <!-- Hardware -->
          <div class="px-4 pb-1">
            <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold mb-2">Hardware</p>
          </div>
          <!-- Hardware with nested flyout -->
          <div class="relative group/hw mx-2 mb-1">
            <a routerLink="/products/hardware" class="flex items-center justify-between gap-3 px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg">
              <div class="flex items-center gap-3">
                <i class='bx bx-chip icon-gradient text-xl'></i>
                <div>
                  <div class="text-white font-semibold text-sm group-hover/hw:text-varroc-accent transition-colors">Hardware Devices</div>
                  <div class="text-varroc-text-gray text-xs">OBD, TCU, DashCam, Cluster</div>
                </div>
              </div>
              <i class='bx bx-chevron-right text-varroc-text-gray text-base flex-shrink-0'></i>
            </a>
            <div class="absolute left-full top-0 ml-2 w-60 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover/hw:opacity-100 group-hover/hw:visible transition-all duration-200 py-3 backdrop-blur-xl z-50">
              <div class="px-4 pb-2 pt-1">
                <p class="text-varroc-text-gray text-xs uppercase tracking-widest font-semibold">Hardware</p>
              </div>
              <a routerLink="/products/hardware/obd" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-plug icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">OBD Dongle</div><div class="text-varroc-text-gray text-xs">Plug & play telematics</div></div>
              </a>
              <a routerLink="/products/hardware/tcu" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-radio icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">TCU</div><div class="text-varroc-text-gray text-xs">Telematics Control Unit</div></div>
              </a>
              <a routerLink="/products/hardware/dashcam" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-camera icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Camzo Dashcam</div><div class="text-varroc-text-gray text-xs">Smart dashcam & app</div></div>
              </a>
              <!-- <a routerLink="/products/hardware/cluster" class="flex items-center gap-3 px-4 py-2 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">
                <i class='bx bx-tachometer icon-gradient text-lg'></i>
                <div><div class="text-white font-semibold text-sm">Digital Cluster</div><div class="text-varroc-text-gray text-xs">Connected instrument display</div></div>
              </a> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Store -->
      <a routerLink="/store/product" class="hover:text-varroc-accent transition px-3 py-2 rounded-lg">Store</a>

      <!-- Resources -->
      <a routerLink="/resources" class="hover:text-varroc-accent transition px-3 py-2 rounded-lg">Resources</a>

      <!-- About Us Dropdown -->
      <div class="relative group">
        <button class="hover:text-varroc-accent transition flex items-center gap-1 px-3 py-2 rounded-lg focus:outline-none">
          About <i class='bx bx-chevron-down text-lg'></i>
        </button>
        <div class="absolute top-full left-0 mt-2 w-56 bg-black border border-varroc-border rounded-2xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2 backdrop-blur-xl">
          <a routerLink="/about-us" class="block px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">About Us</a>
          <a routerLink="/leadership" class="block px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">Leadership</a>
          <a routerLink="/careers" class="block px-4 py-2.5 hover:bg-varroc-dark hover:text-varroc-accent transition rounded-lg mx-2">Careers</a>
        </div>
      </div>

      <a routerLink="/contact-us" class="ml-3 bg-varroc-accent px-6 py-2 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition text-white font-bold tracking-wide text-sm header_contact_us_button">
        Contact Us
      </a>
    </div>

    <!-- Mobile Menu Button -->
    <div class="md:hidden">
      <button id="menuBtn" aria-label="Toggle menu" (click)="toggleSidebar()"
              class="p-2 rounded-lg border border-varroc-border-light hover:bg-varroc-dark transition shadow">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="text-white">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div *ngIf="isOpen" class="md:hidden bg-black border-t border-varroc-border shadow-2xl animate-fade-in-down max-h-[85vh] overflow-y-auto">
    <div class="px-5 py-5 flex flex-col gap-6">

      <div class="flex flex-col gap-1">
        <button (click)="toggleMobileSection('solutions')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
          <span class="flex items-center gap-2">
            <i class='bx bx-briefcase-alt-2 icon-gradient'></i>
            Solutions
          </span>
          <i class='bx text-lg' [class.bx-chevron-down]="!mobileSections.solutions" [class.bx-chevron-up]="mobileSections.solutions"></i>
        </button>
        <div *ngIf="mobileSections.solutions" class="flex flex-col gap-1 pl-2">
          <button (click)="toggleMobileSubsection('solutionsBusiness')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
            <span class="flex items-center gap-2"><i class='bx bx-buildings icon-gradient'></i> Business</span>
            <i class='bx text-lg' [class.bx-chevron-down]="!mobileSubsections.solutionsBusiness" [class.bx-chevron-up]="mobileSubsections.solutionsBusiness"></i>
          </button>
          <div *ngIf="mobileSubsections.solutionsBusiness" class="flex flex-col gap-1">
            <a routerLink="/solutions/business" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition text-sm text-white">Overview</a>
            <a routerLink="/solutions/business/automotive-oem" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-car icon-gradient'></i> Automotive OEM
            </a>
            <a routerLink="/solutions/business/fleet-logistics" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-transfer icon-gradient'></i> Fleet & Logistics
            </a>
            <a routerLink="/products/connectiq/iiot" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-network-chart icon-gradient'></i> IIOT
            </a>
            <a routerLink="/solutions/business/insurance" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-shield-quarter icon-gradient'></i> Insurance (BFSI)
            </a>
            <a routerLink="/solutions/business/enterprise" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-building icon-gradient'></i> Enterprise
            </a>
          </div>
          <button (click)="toggleMobileSubsection('solutionsConsumers')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
            <span class="flex items-center gap-2"><i class='bx bx-user icon-gradient'></i> Consumers</span>
            <i class='bx text-lg' [class.bx-chevron-down]="!mobileSubsections.solutionsConsumers" [class.bx-chevron-up]="mobileSubsections.solutionsConsumers"></i>
          </button>
          <div *ngIf="mobileSubsections.solutionsConsumers" class="flex flex-col gap-1">
            <a routerLink="/solutions/consumers" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition text-sm text-white">Overview</a>
            <a routerLink="/solutions/consumers/connected-car" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-wifi icon-gradient'></i> Connected Car
            </a>
            <a routerLink="/solutions/consumers/safety-alerts" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-bell icon-gradient'></i> Safety & Alerts
            </a>
            <a routerLink="/solutions/consumers/rewards" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-gift icon-gradient'></i> Rewards
            </a>
            <a routerLink="/solutions/consumers/device-store" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-store icon-gradient'></i> Device Store
            </a>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <button (click)="toggleMobileSection('products')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
          <span class="flex items-center gap-2">
            <i class='bx bx-package icon-gradient'></i>
            Products
          </span>
          <i class='bx text-lg' [class.bx-chevron-down]="!mobileSections.products" [class.bx-chevron-up]="mobileSections.products"></i>
        </button>
        <div *ngIf="mobileSections.products" class="flex flex-col gap-1 pl-2">
          <button (click)="toggleMobileSubsection('productsConnectiq')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
            <span class="flex items-center gap-2"><i class='bx bx-wifi icon-gradient'></i> ConnectIQ</span>
            <i class='bx text-lg' [class.bx-chevron-down]="!mobileSubsections.productsConnectiq" [class.bx-chevron-up]="mobileSubsections.productsConnectiq"></i>
          </button>
          <div *ngIf="mobileSubsections.productsConnectiq" class="flex flex-col gap-1">
            <a routerLink="/products/connectiq" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition text-sm text-white">Overview</a>
            <a routerLink="/products/connectiq/secureiq" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-shield-quarter icon-gradient'></i> SecureIQ
            </a>
            <a routerLink="/products/connectiq/iq360" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-message-dots icon-gradient'></i> iQ360
            </a>
            <a routerLink="/products/connectiq/vstore" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-store-alt icon-gradient'></i> V-Store
            </a>
            <a routerLink="/products/connectiq/miles" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <img [src]="GradientIcons.MILES" alt="Varroc Miles icon" class="w-4 h-4 object-contain flex-shrink-0" /> Varroc Miles
            </a>
            <a routerLink="/products/connectiq/cap" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-user-check icon-gradient'></i> CAP
            </a>
            <a routerLink="/products/connectiq/vc-score" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <img [src]="GradientIcons.VC_SCORE" alt="VC-SCORE icon" class="w-4 h-4 object-contain flex-shrink-0" /> VC-SCORE
            </a>
            <a routerLink="/products/connectiq/oasis" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <img [src]="GradientIcons.OASIS" alt="Oasis icon" class="w-4 h-4 object-contain flex-shrink-0" /> Oasis
            </a>
            <a routerLink="/products/connectiq/iiot" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-network-chart icon-gradient'></i> IIOT
            </a>
            <a routerLink="/products/connectiq/vehicle-app-store" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <img [src]="GradientIcons.VEHICLE_APP_STORE" alt="Vehicle App Store icon" class="w-4 h-4 object-contain flex-shrink-0" /> Vehicle App Store
            </a>
          </div>
          <a routerLink="/products/unifiedsdk" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 font-semibold">
            <i class='bx bx-code-block icon-gradient'></i> Unified SDK
          </a>
          <button (click)="toggleMobileSubsection('productsHardware')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
            <span class="flex items-center gap-2"><i class='bx bx-plug icon-gradient'></i> Hardware</span>
            <i class='bx text-lg' [class.bx-chevron-down]="!mobileSubsections.productsHardware" [class.bx-chevron-up]="mobileSubsections.productsHardware"></i>
          </button>
          <div *ngIf="mobileSubsections.productsHardware" class="flex flex-col gap-1">
            <a routerLink="/products/hardware" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition text-sm text-white">Overview</a>
            <a routerLink="/products/hardware/obd" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-plug icon-gradient'></i> OBD Dongle
            </a>
            <a routerLink="/products/hardware/tcu" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-radio icon-gradient'></i> TCU
            </a>
            <a routerLink="/products/hardware/dashcam" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-camera icon-gradient'></i> Camzo Dashcam
            </a>
            <!-- <a routerLink="/products/hardware/cluster" (click)="toggleSidebar()" class="py-2 px-3 pl-8 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 text-sm text-varroc-text-gray">
              <i class='bx bx-tachometer icon-gradient'></i> Digital Cluster
            </a> -->
          </div>
        </div>
        <a routerLink="/store/product" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 font-semibold">
          <i class='bx bx-shopping-bag icon-gradient'></i> Store
        </a>
        <a routerLink="/resources" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center gap-2 font-semibold">
          <i class='bx bx-book-open icon-gradient'></i> Resources
        </a>
      </div>

      <div class="flex flex-col gap-1">
        <button (click)="toggleMobileSection('about')" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition flex items-center justify-between gap-2 font-semibold text-left">
          <span class="flex items-center gap-2">
            <i class='bx bx-info-circle icon-gradient'></i>
            About
          </span>
          <i class='bx text-lg' [class.bx-chevron-down]="!mobileSections.about" [class.bx-chevron-up]="mobileSections.about"></i>
        </button>
        <div *ngIf="mobileSections.about" class="flex flex-col gap-1 pl-2">
          <a routerLink="/about-us" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition">About Us</a>
          <a routerLink="/leadership" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition">Leadership</a>
          <a routerLink="/careers" (click)="toggleSidebar()" class="py-2.5 px-3 hover:text-varroc-accent hover:bg-varroc-dark rounded-lg transition">Careers</a>
        </div>
      </div>

      <div class="flex flex-col gap-3 pt-2 border-t border-varroc-border">
        <a routerLink="/store/product" (click)="toggleSidebar()" class="bg-varroc-accent px-5 py-3 rounded-md text-center hover:bg-varroc-accent-hover hover:shadow-neon transition text-white font-bold tracking-wide flex items-center justify-center gap-2">
          <i class='bx bx-shopping-bag'></i> Go To Store
        </a>
        <a routerLink="/contact-us" (click)="toggleSidebar()" class="border border-varroc-accent text-varroc-accent px-5 py-3 rounded-md text-center hover:bg-varroc-accent hover:text-white transition font-bold tracking-wide">
          Contact Us
        </a>
      </div>
    </div>
  </div>
</nav>
